export default __webpack_public_path__ + "static/media/VD.26e0310c.png";